// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tab_prize[data-v-5d17299f] {\n  margin: 0.32rem 0.4266666667rem 0;\n}\n.hot_none.ft_bm[data-v-5d17299f] {\n  font-weight: 500;\n}", ""]);
// Exports
module.exports = exports;
